import React from 'react';
import PdfIcon from './pdf';


export const TwoToThree = () => {
  return (
    <div className="container mx-auto px-4">
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">Standards</h2>
        <ul className="list-disc pl-5">
          <li className="mb-2"><strong>2.9A:</strong> Name current public officials, including mayor, governor, and president.</li>
          <li className="mb-2"><strong>2.9B:</strong> Compare the roles of public officials, including mayor, governor, and president.</li>
          <li className="mb-2"><strong>2.9C:</strong> Identify ways that public officials are selected, including election and appointment to office.</li>
          <li className="mb-2"><strong>3.7B:</strong> Identify local, state, and national government officials and explain how they are chosen.</li>
          <li className="mb-2"><strong>3.9A:</strong> Identify characteristics of good citizenship including truthfulness, justice, equality, respect for oneself and others, responsibility in daily life, and participation in government by educating oneself about the issues, respectfully holding public officials to their word, and voting.</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">Objectives</h2>
        <p className="mb-2">Students will:</p>
        <ol className="list-decimal pl-5">
          <li className="mb-2">Identify local, state, and national government officials.</li>
          <li className="mb-2">Explain the process of voting and the importance of voter participation.</li>
          <li className="mb-2">Describe how voting is a key responsibility of good citizenship.</li>
        </ol>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">Lesson Plan</h2>
        <a href={`${process.env.PUBLIC_URL}/lessons/2-3_LessonPlan.pdf`} target='_blank' rel='noreferrer' className="hover:underline">
        Click for Lesson Plan <PdfIcon />
        </a>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">Activities</h2>
        <div className="grid md:grid-cols-3 gap-6">
          <div className="border p-4 rounded-lg">
            <h3 className="text-xl font-medium mb-2">
              <a href={`${process.env.PUBLIC_URL}/lessons/2-3_UnderstandingGovernment-LocalStateAndNational.pdf`} target='_blank' rel='noreferrer'>Understanding Government Officials Reading Passage <PdfIcon /></a>
            </h3>
            <p>This reading passage can be used independently or in a whole-group setting to educate students on local, state, and national government officials.</p>
          </div>

          <div className="border p-4 rounded-lg">
            <h3 className="text-xl font-medium mb-2">
              <a href={`${process.env.PUBLIC_URL}/lessons/2-3_WhoAmICards.pdf`} target='_blank' rel='noreferrer'>Who Am I? Cards <PdfIcon /></a>
            </h3>
            <p>Use these cards to teach and review local, state, and national government officials and how they are chosen.</p>
          </div>

          <div className="border p-4 rounded-lg">
            <h3 className="text-xl font-medium mb-2">
              <a href={`${process.env.PUBLIC_URL}/lessons/2-3_LocalStateNationalSort.pdf`} target='_blank' rel='noreferrer'>Sorting Sheet  <PdfIcon /></a>
            </h3>
            <p>This sorting activity helps students categorize government officials into their correct levels: local, state, and national.</p>
          </div>

          <div className="border p-4 rounded-lg">
            <h3 className="text-xl font-medium mb-2">
              <a href={`${process.env.PUBLIC_URL}/lessons/2-3_UnderstandingGovernmentQuiz.pdf`} target='_blank' rel='noreferrer'>Understanding Government Quiz  <PdfIcon /></a>
            </h3>
            <p>This quiz assesses students' understanding of local, state, and national government officials.</p>
          </div>
        </div>
      </section>
    </div>
  );
}

export const FourToFive = () => {
  return (
    <div className="container mx-auto px-4">
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">Standards</h2>
        <ul className="list-disc pl-5">
          <li className="mb-2">
            <strong>4.15C:</strong> Explain the duty of the individual in state and local elections such as being informed and voting.
          </li>
          <li className="mb-2">
            <strong>4.15F:</strong> Use voting as a method for group decision-making.
          </li>
          <li className="mb-2">
            <strong>5.17A:</strong> Explain why individuals have a duty to participate in civic affairs at the local, state, and national levels.
          </li>
          <li className="mb-2">
            <strong>5.17C:</strong> Use voting as a method for group decision-making.
          </li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">Objectives</h2>
        <p className="mb-2">Students will:</p>
        <ol className="list-decimal pl-5">
          <li className="mb-2">Explain the responsibility of individuals to be informed and vote in state and local elections.</li>
          <li className="mb-2">Demonstrate the use of voting as a method for making group decisions.</li>
        </ol>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">Lesson Plan</h2>
        <a href={`${process.env.PUBLIC_URL}/lessons/4-5_LessonPlan.pdf`} target="_blank" rel="noreferrer" className="hover:underline">
          Click for Lesson Plan  <PdfIcon />
        </a>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">Activities</h2>
        <div className="grid md:grid-cols-3 gap-6">
          <div className="border p-4 rounded-lg">
            <h3 className="text-xl font-medium mb-2">
              <a href={`${process.env.PUBLIC_URL}/lessons/4-5_CivicResponsibility.pdf`} target="_blank" rel="noreferrer">
                Understanding Government Officials Reading Passage  <PdfIcon />
              </a>
            </h3>
            <p>
              This passage and associated quiz explains the concept of civic responsibility in a democratic society, emphasizing the importance of being informed, voting, respecting others' opinions, volunteering, and holding leaders accountable.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export const Eight = () => {
  return (
    <div className="container mx-auto px-4">
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">Standards</h2>
        <ul>
          <li className="mb-2"><strong>8.21: Citizenship</strong> The student understands the importance of the expression of different points of view in a constitutional republic. The student is expected to:</li>
          <ul className="list-disc pl-5">
            <li className="mb-2"><strong>A:</strong> Identify different points of view of political parties and interest groups on important historical issues.</li>
            <li className="mb-2"><strong>B:</strong> Describe the importance of free speech and press in a constitutional republic.</li>
          </ul>
          <li className="mb-2"><strong>8.16: Citizenship</strong> The student understands the rights and responsibilities of citizens of the United States. The student is expected to:</li>
          <ul className="list-disc pl-5">
            <li className="mb-2"><strong>A:</strong> Define and give examples of unalienable rights.</li>
            <li className="mb-2"><strong>C:</strong> Identify examples of responsible citizenship, including obeying rules and laws, staying informed on public issues, voting, and serving on juries.</li>
          </ul>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">Objectives</h2>
        <p className="mb-2">Students will:</p>
        <ol className="list-decimal pl-5">
          <li className="mb-2">Students will identify different points of view of political parties and interest groups on important historical and contemporary issues. (Aligned with TEKS 8.21A)</li>
          <li className="mb-2">Students will evaluate the importance of free speech and press in a constitutional republic. (Aligned with TEKS 8.21B)</li>
          <li className="mb-2">Students will define and give examples of unalienable rights. (Aligned with TEKS 8.16A)</li>
          <li className="mb-2">Students will explain the importance of personal responsibilities, including voting, obeying laws, serving on juries, and paying taxes. (Aligned with TEKS 8.16C)</li>
        </ol>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">Lesson Plan</h2>
        <a href={`${process.env.PUBLIC_URL}/lessons/8_LessonPlan.pdf`} target="_blank" rel="noreferrer" className="hover:underline">
          Click for Lesson Plan  <PdfIcon />
        </a>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">Activities</h2>
        <div className="grid md:grid-cols-3 gap-6">
          <div className="border p-4 rounded-lg">
            <h3 className="text-xl font-medium mb-2">
              <a href={`${process.env.PUBLIC_URL}/lessons/8_FVsDR.pdf`} target="_blank" rel="noreferrer">
                Early American Political Parties Reading Passage  <PdfIcon />
              </a>
            </h3>
            <p>
              This passage outlines the early political divide between Federalists, who supported a strong central government and industry, and Democratic-Republicans, who favored limited government and an agrarian economy.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};


export const HSAH = () => {
  return (
    <div className="container mx-auto px-4">
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">Standards</h2>
        <ul>
          <li className="mb-2"><strong>22 Citizenship</strong> The student understands the promises of the Declaration of Independence and the protections of the U.S. Constitution and the Bill of Rights. The student is expected to:</li>
          <ul className="list-disc pl-5">
            <li className="mb-2"><strong>C:</strong> Explain how participation in the democratic process reflects our national identity, patriotism, and civic responsibility.</li>
          </ul>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">Objectives</h2>
        <p className="mb-2">Students will:</p>
        <ol className="list-decimal pl-5">
          <li className="mb-2">Understand how the extension of the Voting Rights Act in 1982, as articulated in President Ronald Reagan's speech, reinforces the principles of national identity, patriotism, and civic responsibility.</li>
        </ol>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">Lesson Plan</h2>
        <a href={`${process.env.PUBLIC_URL}/lessons/HSAH_LessonPlan.pdf`} target='_blank' rel='noreferrer' className="hover:underline">
          Click for Lesson Plan  <PdfIcon />
        </a>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">Activities</h2>
        <div className="grid md:grid-cols-3 gap-6">
          <div className="border p-4 rounded-lg">
            <h3 className="text-xl font-medium mb-2">
              <a href={`${process.env.PUBLIC_URL}/lessons/HSAH_VotingRightsAct.pdf`} target='_blank' rel='noreferrer'>
                Voting Rights Act Context  <PdfIcon />
              </a>
            </h3>
            <p>This passage covers the 1982 extension of the Voting Rights Act, which upheld protections against voter discrimination and supported language minorities.</p>
          </div>

          <div className="border p-4 rounded-lg">
            <h3 className="text-xl font-medium mb-2">
              <a href={`${process.env.PUBLIC_URL}/lessons/HSAH_ReaganVotingRightsAct.pdf`} target='_blank' rel='noreferrer'>
                President Reagan's Remarks on the Voting Rights Act  <PdfIcon />
              </a>
            </h3>
            <p>President Reagan's remarks upon signing the Voting Rights Act in 1982.</p>
          </div>

          <div className="border p-4 rounded-lg">
            <h3 className="text-xl font-medium mb-2">
              <a href={`${process.env.PUBLIC_URL}/lessons/HSAH_Quotes.pdf`} target='_blank' rel='noreferrer'>
                Quotes About Civic Responsibility  <PdfIcon />
              </a>
            </h3>
            <p>These quotes from famous Americans speak to the importance of civic responsibility and the democratic process.</p>
          </div>
        </div>
      </section>
    </div>
  );
};


export const HSGov = () => {
  return (
    <div className="container mx-auto px-4">
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">Standards</h2>
        <ul>
          <li className="mb-2"><strong>10</strong> The student understands the role of political parties in the U.S. system of government. The student is expected to:</li>
          <ul className="list-disc pl-5">
            <li className="mb-2"><strong>A</strong> Analyze the functions of political parties and their role in the electoral process at local, state, and national levels.</li>
            <li className="mb-2"><strong>B</strong> Explain the two-party system and evaluate the role of third parties in the United States.</li>
          </ul>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">Objectives</h2>
        <p className="mb-2">Students will:</p>
        <ol className="list-decimal pl-5">
          <li className="mb-2">Understand the processes for filling public offices in the U.S., specifically focusing on the Electoral College and the impact of the 17th Amendment on civic engagement.</li>
        </ol>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">Lesson Plan</h2>
        <a href={`${process.env.PUBLIC_URL}/lessons/HSG_LessonPlan.pdf`} target='_blank' rel='noreferrer' className="hover:underline">
          Click for Lesson Plan  <PdfIcon />
        </a>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">Activities</h2>
        <div className="grid md:grid-cols-3 gap-6">
          <div className="border p-4 rounded-lg">
            <h3 className="text-xl font-medium mb-2">
              <a href={`${process.env.PUBLIC_URL}/lessons/HSG_ElectoralCollege.pdf`} target='_blank' rel='noreferrer'>
                Electoral College Project  <PdfIcon />
              </a>
            </h3>
            <p>This activity engages students in analyzing electoral votes, swing state dynamics, historical voting patterns, and the relationship between population size and electoral influence in U.S. elections.</p>
          </div>

          <div className="border p-4 rounded-lg">
            <h3 className="text-xl font-medium mb-2">
              <a href={`${process.env.PUBLIC_URL}/lessons/HSG_MyCampaignPoster.pdf`} target='_blank' rel='noreferrer'>
                My Campaign Poster  <PdfIcon />
              </a>
            </h3>
            <p>Students will design a campaign poster for a fictional run for office at the county, state, or national level. The poster should communicate the candidate’s platform using visual and textual elements to engage voters.</p>
          </div>

          <div className="border p-4 rounded-lg">
            <h3 className="text-xl font-medium mb-2">
              <a href={`${process.env.PUBLIC_URL}/lessons/HSG_ElectoralQuiz.pdf`} target='_blank' rel='noreferrer'>
                Electoral Process Quiz  <PdfIcon />
              </a>
            </h3>
            <p>This quiz provides an overview of the key elements of the electoral process and civic responsibilities in the U.S. government system.</p>
          </div>

          <div className="border p-4 rounded-lg">
            <h3 className="text-xl font-medium mb-2">
              <a href={`${process.env.PUBLIC_URL}/lessons/HSG_EmpoweringDemocracy.pptx`} target='_blank' rel='noreferrer'>
                Empowering Democracy  (PowerPoint)
              </a>
            </h3>
            <p>This PowerPoint presentation emphasizes the importance of voter registration, outlines different types of elections, appointed positions, and the role of the Electoral College in U.S. presidential elections.</p>
          </div>
        </div>
      </section>
    </div>
  );
};
